import React, { useEffect, useState } from "react";
import { BadgeCheck, AlertTriangle } from "lucide-react";
import { areaSearch } from "@/lib/api";

const norm = (v) => (v || "").trim().toLowerCase();

// Official district for a PIN (VerB list or India Post) shown beside the vendor's own city/state.
export default function PinDistrictHint({ pincode, city, state, onUse }) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    setInfo(null);
    if (!/^\d{6}$/.test(pincode || "")) return;
    let alive = true;
    const t = setTimeout(() => {
      areaSearch(pincode).then((d) => alive && setInfo(d?.districts?.length ? d.districts : null)).catch(() => {});
    }, 400);
    return () => { alive = false; clearTimeout(t); };
  }, [pincode]);
  if (!info) return null;
  const match = info.some((d) => norm(d.district) === norm(city) && norm(d.state) === norm(state));
  return (
    <div className="sm:col-span-2 -mt-1 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs" data-testid="pin-district-hint">
      <div className="flex items-center gap-1.5 text-slate-700 font-semibold">
        <BadgeCheck className="w-3.5 h-3.5 text-emerald-700" /> Official district for PIN {pincode} ({info[0].source})
      </div>
      <div className="mt-1 flex flex-wrap gap-1.5">
        {info.map((d) => (
          <span key={`${d.district}-${d.state}`} className="inline-flex items-center gap-1.5 rounded-full bg-white border border-slate-200 px-2.5 py-1" data-testid={`pin-district-${d.district}`}>
            {d.district}, {d.state}
            {!match && (
              <button type="button" onClick={() => onUse(d.district, d.state)} className="font-semibold text-emerald-700 hover:underline" data-testid={`pin-district-use-${d.district}`}>Use this</button>
            )}
          </span>
        ))}
      </div>
      {match ? (
        <div className="mt-1 text-emerald-700" data-testid="pin-district-match">Your City/State matches the official district.</div>
      ) : (
        <div className="mt-1 text-amber-700 inline-flex items-start gap-1" data-testid="pin-district-mismatch">
          <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0 mt-px" />
          Your City/State ({city || "blank"}{state ? `, ${state}` : ""}) differs from the official district. You can still save — City is your own locality text.
        </div>
      )}
    </div>
  );
}
